export const API = {
  INSTANCE: 'https://payment.finsense.co',
  // INSTANCE: 'https://localhost:44345',
  LOGIN: '/member/login',
  GET_COMPANY: '/company',
  POST_BRANCH_FILTER: '/branch/filter',
  POST_INQUIRY_DASHBOARD: '/inquiry/dashboard',
  POST_DEVICE_FILTER: '/device/filter',
  POST_INQUIRY_TRANSACTION: '/inquiry/transaction',
  POST_INQUIRY_CHARGE: '/inquiry/charge',
  POST_INQUIRY_CHART: '/inquiry/chart'
};
